import { getLatestArtifact } from 'redux-request-state/selectors/artifactSelectors';
import * as requestKeys from 'web-interactives-dashboard-ui/utils/requestStateKeys';
export const buildRequestStateSelector = requestKey => state => getLatestArtifact(state, {
  requestKey
});
export const getAnalyzeDataRequest = buildRequestStateSelector(requestKeys.FETCH_ANALYZE_DATA_REQUEST);
export const getDeleteInteractiveRequest = buildRequestStateSelector(requestKeys.DELETE_INTERACTIVE_REQUEST);
export const getCloneInteractiveRequest = buildRequestStateSelector(requestKeys.CLONE_INTERACTIVE_REQUEST);
export const getFetchPropertiesRequest = buildRequestStateSelector(requestKeys.FETCH_PROPERTIES_REQUEST);
export const getFetchDetailsRequest = buildRequestStateSelector(requestKeys.FETCH_DETAILS_REQUEST);
export const getCreateInteractiveRequest = buildRequestStateSelector(requestKeys.CREATE_INTERACTIVE_REQUEST);
export const getFetchTemplatesRequest = buildRequestStateSelector(requestKeys.FETCH_TEMPLATES_REQUEST);
export const getAiCtaGenerationRequest = buildRequestStateSelector(requestKeys.GENERATE_AI_CTA_REQUEST);
export const getRequestStatesForKeys = (state, keys) => keys.map(requestKey => getLatestArtifact(state, {
  requestKey
}));